import React from 'react';
interface TileOption {
  label: string;
  icon?: React.ReactNode;
}
interface TileOptionGridProps {
  options: TileOption[];
  value: string;
  onChange: (value: any) => void;
}
export function TileOptionGrid({
  options,
  value,
  onChange
}: TileOptionGridProps) {
  return <div className="grid grid-cols-2 gap-3" data-id="element-244">
      {options.map(option => {
      const isSelected = value === option.label;
      return <button key={option.label} onClick={() => onChange(option.label)} className={`
              relative flex flex-col items-center justify-center p-4 rounded-xl border transition-all h-32
              ${isSelected ? 'border-violet-600 bg-violet-50 ring-1 ring-violet-600' : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'}
            `} data-id="element-245">
            {/* Placeholder circle for material sample */}
            <div className={`w-12 h-12 rounded-full mb-3 ${isSelected ? 'bg-violet-200' : 'bg-gray-200'}`} data-id="element-246" />

            <span className={`text-sm font-medium ${isSelected ? 'text-violet-900' : 'text-gray-700'}`} data-id="element-247">
              {option.label}
            </span>
          </button>;
    })}
    </div>;
}